import { CurrencyPipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import { Component, EventEmitter, inject, Inject, Input, LOCALE_ID, Output, OnChanges } from '@angular/core';
import { LocalizationConfigService, StoreConfigService, StoreSpecificConfigService } from '@scalefast/config-angular';
import { CartProduct } from '@scalefast/core';
import { LoginService, StaticFileHash } from '@scalefast/ecommerce-core';
import { AnalyticsStoreService } from 'src/app/shared/services';
import { AppMinicartItemComponent } from '../minicart-item/minicart-item.component';

@Component({
  selector: 'app-minicart-template',
  templateUrl: './minicart-template.component.html',
  styleUrls: ['./minicart-template.component.scss'],
  standalone: true,
  imports: [AppMinicartItemComponent, CurrencyPipe, StaticFileHash],
})
export class AppMinicartTemplateComponent implements OnChanges {
  @Input() cartCount = 0;
  @Input() cartTotal = 0;
  @Input() currency = '';
  @Input() cartUrl = 'cart';
  @Input() productsTillCartFull = 0;
  @Input() products: CartProduct[] = [];
  @Output() removeFromCartData = new EventEmitter<CartProduct>();
  @Output() updateCartData = new EventEmitter<CartProduct>();

  protected freeShippingValue: number;
  protected freeShippingFeeds: Array<number> = [];
  readonly currencySymbol: string;
  loginUrl: string;

  constructor(
    private localizationConfigService: LocalizationConfigService,
    private analyticsStoreService: AnalyticsStoreService,
    @Inject(LOCALE_ID) protected locale: string,
    private loginService: LoginService,
    private storeSpecificConfigService: StoreSpecificConfigService,
  ) {
    this.freeShippingValue = storeSpecificConfigService.get().freeShippingValue;
    this.freeShippingFeeds = storeSpecificConfigService.get().freeShippingFeeds;
    this.currency = this.localizationConfigService.get().currency;
    this.currencySymbol = getCurrencySymbol(this.currency, 'narrow', this.locale);
    this.loginUrl = inject(StoreConfigService).getCustomRoutes()?.login ?? 'sso_login';
  }

  ngOnChanges() {
    if (this.products.length > 0) {
      for (let product of this.products) {
        if (product?.product?.v4ApiResponse?.feedID) {
          let productFeeds = product.product.v4ApiResponse.feedID.split(',') || [];
          productFeeds = productFeeds.map((number: any) => parseInt(number));
          for (let feed of productFeeds) {
            if (this.freeShippingFeeds.includes(feed)) {
              this.freeShippingValue = 0;
              break;
            }
          }
        }
      }
    }
  }

  onUpdateCart(data: CartProduct) {
    this.updateCartData.emit(data);
  }

  onRemoveFromCart(data: CartProduct) {
    this.removeFromCartData.emit(data);
  }

  addAllToWhishlist() {
    console.log('addAllToWhishlist');
  }

  prodTracker = (index: number, product: CartProduct) => product.productId;

  get storeCurrency(): string {
    return this.currency;
  }

  gtmEvent(event: any): void {
    const category = event.currentTarget.getAttribute('data-gtmcategory');
    const action = event.currentTarget.getAttribute('data-gtmaction');
    const label = 'Proceed to Step 1:Cart';
    this.analyticsStoreService.miscEvent(category, action, label);
  }

  freeShippingCalculation() {
    return formatCurrency(this.freeShippingValue - this.cartTotal, this.locale, this.currencySymbol, this.currency, '1.2-2');
  }

  goToCart(): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the cart page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the cart page is hosted in v5 we need to make the switch to angular router navigate.
     */
    /* window.location.href = this.loginService.isLoggedSync() ? this.cartUrl : `${this.loginUrl}?redirectTo=/cart`; */
    window.location.href = this.cartUrl;
  }
}
